var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-none d-lg-flex flex-row justify-content-around" },
      [
        _c(
          "inline-prompt",
          {
            staticClass: "clickable",
            staticStyle: { "font-size": "0.8rem" },
            attrs: {
              disabled: _vm.isDisabledButtons || _vm.disabled,
              "action-type": "delete",
              placement: "left",
              "confirmation-text": _vm.$t("global.words.continue"),
              "accept-text-class": "bg-primary",
            },
            on: {
              accept: function ($event) {
                return _vm.handleClick("copy")
              },
            },
            scopedSlots: _vm._u([
              {
                key: "preConfirmationContent",
                fn: function () {
                  return [
                    _c("p", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "direct-to-lender.creditBureau.liabilitiesCopiedWillNotBeSubmitted"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-row mr-3" },
              [
                _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "primary",
                      "class-name": "btn-sm",
                      disabled: _vm.isDisabledButtons || _vm.disabled,
                      loading: _vm.loading.copy,
                      "loading-succeeded": _vm.status.copy,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.creditBureau.copyLiabilities"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.right",
                value: {
                  title: _vm.$t("documents.notDocumentsForPreview"),
                  disabled: _vm.allowPreview,
                  boundary: "viewport",
                },
                expression:
                  "{\n        title: $t('documents.notDocumentsForPreview'),\n        disabled: allowPreview,\n        boundary: 'viewport'\n      }",
                modifiers: { right: true },
              },
            ],
          },
          [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "primary",
                  "class-name": "btn-sm",
                  disabled: !_vm.allowPreview || _vm.isDisabledButtons,
                  loading: _vm.loading.preview,
                  "loading-succeeded": _vm.status.preview,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick("preview")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.words.preview")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dropleft" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-menu" }, [
        _c("div", { staticClass: "dropdown-item clickable wide" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: { disabled: _vm.isDisabledButtons },
              on: {
                click: function ($event) {
                  return _vm.handleClick("copy")
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("direct-to-lender.creditBureau.copyLiabilities")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-item clickable wide" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: { disabled: _vm.isDisabledButtons || !_vm.allowPreview },
              on: {
                click: function ($event) {
                  return _vm.handleClick("preview")
                },
              },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("global.words.preview")) +
                  "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }